export default __webpack_public_path__ + "static/media/ourclient5.88dc9d0b.png";